import skin3000 from "./skin3000";
import skin3001 from "./skin3001";
import type { LeadFormSkinDefinition } from "./types";

export type { LeadFormSkinDefinition, LeadFormSkinClasses } from "./types";

/**
 * The skin registry — developer-authored, deliberately short.
 *
 * Mirrors `LEAD_FORM_SKIN` in `server/constants/leadForm.js`. The server normalises an
 * unknown `template_key` to the default skin, and `resolveLeadFormSkin` below does the
 * same on the client, so the two agree even if a row is written by a newer build than the
 * one rendering it.
 *
 * To add a skin: write `skinNNNN.ts`, register it here, and add the id to the server
 * constant. Nothing else changes — no renderer, no schema, no migration.
 */
export const LEAD_FORM_SKINS: Record<string, LeadFormSkinDefinition> = {
  [skin3000.id]: skin3000,
  [skin3001.id]: skin3001,
};

/** The skin every config is guaranteed to render under. */
export const DEFAULT_LEAD_FORM_SKIN_ID = skin3000.id;

/** Ordered list for the admin picker. */
export const LEAD_FORM_SKIN_LIST: LeadFormSkinDefinition[] = Object.values(LEAD_FORM_SKINS);

/**
 * Never returns undefined. A config carrying a legacy `template_1` or a typo must render
 * under a working design rather than crash the page it sits on.
 */
export const resolveLeadFormSkin = (id: string | null | undefined): LeadFormSkinDefinition =>
  LEAD_FORM_SKINS[String(id ?? "").trim()] ?? LEAD_FORM_SKINS[DEFAULT_LEAD_FORM_SKIN_ID];
